<template>
	<span>
		<button v-show="!entity.editMode" class="pull-right btn btn-success f16" @click="callback" :disabled="entity.loading">
						<i class="fa fa-plus" v-show="!entity.loading"></i>
						<i class="fa fa-spinner fa-spin" v-show="entity.loading"></i>
						创建
					</button>
					<button v-show="entity.editMode" class="pull-right btn btn-primary f16" @click="callback"
					        :disabled="entity.loading">
						<i class="fa fa-save" v-show="!entity.loading"></i>
						<i class="fa fa-spinner fa-spin" v-show="entity.loading"></i>
						保存
					</button>
	</span>

</template>
<script>

	import Base from "../../../common/model/base/Base";

	export default{
		data(){
			return {
				content: null
			}
		},
		watch: {},
		props: {
			entity: {
				type: Base,
				required: true
			},
			callback: {
				type: Function,
				required: true
			}
		},
		methods: {
			setContent(content){
				this.content = content;
			}
		},
		components: {},
		mounted(){

		}
	}
</script>



// WEBPACK FOOTER //
// CreateSaveButton.vue?ab1c1ffe